import React from 'react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { UniversalLink } from '@plone/volto/components';
import './TeamListingTemplate.css';

const TeamListingTemplate = ({ items }) => {
  return (
    <div className="team-listing">
      <div className="team-members-grid">
        {items.map((member) => (
          <UniversalLink
            style={{ textDecoration: 'none' }}
            key={member['@id']}
            href={member.social_media_link}
          >
            <div className="team-member-card">
              {member.team_member_image && (
                <img
                  src={flattenToAppURL(
                    member.team_member_image.scales.great.download,
                  )}
                  alt={member.title}
                  className="team-member-image"
                />
              )}
              <h2 className="team-member-name">
                {member.team_member_name || member.title}
              </h2>
              <p className="team-member-occupation">{member.occupation}</p>
              {member.social_media_icon && (
                <img
                  src={flattenToAppURL(
                    member.social_media_icon.scales.great.download,
                  )}
                  alt="Social Media"
                  className="social-media-icon"
                />
              )}
            </div>
          </UniversalLink>
        ))}
      </div>
    </div>
  );
};

export default TeamListingTemplate;
